import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Box } from 'shared/mui/Box';
import { Button } from 'shared/mui/Buttons';
import { CardActionsButtons, CardHeader } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { Dialog } from 'shared/mui/Dialogs';
import { Divider } from 'shared/mui/Divider/Divider';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { TypographyTitle, TypographyWithBold } from 'shared/mui/Typography';
import { TypographyBold } from 'shared/mui/Typography/TypographyBold';

import { UlStyled } from './OrderAdjustmentsReferenceDialog.styled';

type Props = {
  open: boolean;
  onClose: VoidFunction;
};

export const OrderAdjustmentsReferenceDialog: React.FC<Props> = ({ open, onClose }) => {
  const translate = useTypedTranslate();

  return (
    <Dialog onClose={onClose} open={open} width="640px">
      <Box>
        <CardHeader
          appendActions={<CloseIconButton key="close-button" onClose={onClose} />}
          title={translate('app.orderAdjustmentsReference.subtitle')}
          titleSize="smallBold"
        />
        <CardContent>
          <TypographyWithBold text={translate('app.orderAdjustmentsReference.intro1')} />
          <TypographyWithBold
            sx={{ marginTop: '12px' }}
            text={translate('app.orderAdjustmentsReference.intro2')}
          />
          <Divider sx={{ margin: '12px 0' }} />
          <TypographyTitle fontWeight={500} size="xsmall">
            {translate('app.orderAdjustmentsReference.type1Title')}
          </TypographyTitle>
          <TypographyWithBold text={translate('app.orderAdjustmentsReference.type1Description')} />
          <TypographyBold text={translate('app.orderAdjustmentsReference.result')} />
          <UlStyled sx={{ marginLeft: '18px' }}>
            <li>
              <TypographyWithBold text={translate('app.orderAdjustmentsReference.type1Result1')} />
            </li>
            <li>
              <TypographyWithBold text={translate('app.orderAdjustmentsReference.type1Result2')} />
            </li>
            <li>
              <TypographyWithBold text={translate('app.orderAdjustmentsReference.type1Result3')} />
            </li>
          </UlStyled>
          <Divider sx={{ margin: '12px 0' }} />
          <TypographyTitle fontWeight={500} size="xsmall">
            {translate('app.orderAdjustmentsReference.type2Title')}
          </TypographyTitle>
          <TypographyWithBold text={translate('app.orderAdjustmentsReference.type2Description')} />
          <TypographyBold text={translate('app.orderAdjustmentsReference.result')} />
          <UlStyled sx={{ marginLeft: '18px' }}>
            <li>
              <TypographyWithBold text={translate('app.orderAdjustmentsReference.type2Result1')} />
            </li>
            <li>
              <TypographyWithBold text={translate('app.orderAdjustmentsReference.type2Result2')} />
            </li>
            <li>
              <TypographyWithBold text={translate('app.orderAdjustmentsReference.type2Result3')} />
            </li>
          </UlStyled>
          <Divider sx={{ margin: '12px 0' }} />
          <TypographyTitle fontWeight={500} size="xsmall">
            {translate('app.orderAdjustmentsReference.type3Title')}
          </TypographyTitle>
          <TypographyWithBold text={translate('app.orderAdjustmentsReference.type3Description')} />
          <TypographyBold text={translate('app.orderAdjustmentsReference.result')} />
          <UlStyled sx={{ marginLeft: '18px' }}>
            <li>
              <TypographyWithBold text={translate('app.orderAdjustmentsReference.type3Result1')} />
            </li>
            <li>
              <TypographyWithBold text={translate('app.orderAdjustmentsReference.type3Result2')} />
            </li>
            <li>
              <TypographyWithBold text={translate('app.orderAdjustmentsReference.type3Result3')} />
            </li>
          </UlStyled>
          <Divider sx={{ margin: '12px 0' }} />
          <TypographyTitle fontWeight={500} size="xsmall">
            {translate('app.orderAdjustmentsReference.type4Title')}
          </TypographyTitle>
          <TypographyWithBold text={translate('app.orderAdjustmentsReference.type4Description')} />
          <TypographyBold text={translate('app.orderAdjustmentsReference.result')} />
          <UlStyled sx={{ marginLeft: '18px' }}>
            <li>
              <TypographyWithBold text={translate('app.orderAdjustmentsReference.type4Result1')} />
            </li>
            <li>
              <TypographyWithBold text={translate('app.orderAdjustmentsReference.type4Result2')} />
            </li>
            <li>
              <TypographyWithBold text={translate('app.orderAdjustmentsReference.type4Result3')} />
            </li>
          </UlStyled>
          <Divider sx={{ margin: '12px 0' }} />
          <TypographyTitle fontWeight={500} size="xsmall">
            {translate('app.orderAdjustmentsReference.type5Title')}
          </TypographyTitle>
          <TypographyWithBold text={translate('app.orderAdjustmentsReference.type5Description')} />
          <TypographyBold text={translate('app.orderAdjustmentsReference.result')} />
          <UlStyled sx={{ marginLeft: '18px' }}>
            <li>
              <TypographyWithBold text={translate('app.orderAdjustmentsReference.type5Result1')} />
            </li>
            <li>
              <TypographyWithBold text={translate('app.orderAdjustmentsReference.type5Result2')} />
            </li>
            <li>
              <TypographyWithBold text={translate('app.orderAdjustmentsReference.type5Result3')} />
            </li>
            <li>
              <TypographyWithBold text={translate('app.orderAdjustmentsReference.type5Result4')} />
            </li>
          </UlStyled>
          <Divider sx={{ margin: '12px 0' }} />
          <TypographyTitle fontWeight={500} size="xsmall">
            {translate('app.orderAdjustmentsReference.type6Title')}
          </TypographyTitle>
          <TypographyWithBold text={translate('app.orderAdjustmentsReference.type6Description')} />
          <TypographyBold text={translate('app.orderAdjustmentsReference.result')} />
          <UlStyled sx={{ marginLeft: '18px' }}>
            <li>
              <TypographyWithBold text={translate('app.orderAdjustmentsReference.type6Result1')} />
            </li>
            <li>
              <TypographyWithBold text={translate('app.orderAdjustmentsReference.type6Result2')} />
            </li>
          </UlStyled>
        </CardContent>
      </Box>
      <CardActionsButtons
        rightActionsSlot={[
          <Button
            key="cancel-button"
            label={translate('app.buttons.close')}
            onClick={onClose}
            variant="outlined"
          />,
        ]}
      />
    </Dialog>
  );
};
